<template>
	<div class="channel">
		<div class="cooperate">
			<div class="cooperate_con">
				<p class="f16 red blod">CHANNEL COOPERATION</p>
				<p class="f36 blod title">渠道合作</p>
				<p class="f14">联丰典当成立于2008年，是一家经国家金融监督管理局批准的专业典当服务机构</p>
			</div>
			<div class="channer-apply">
				<div class="left">
					<p class="mb-30">联丰典当，诚邀合作伙伴！（安徽全省区域）</p>
					<p>联丰典当专注典当金融服务，致力于为个人与中小企业提供便捷、高效的资金解决方案。凭借多年的行业深耕，已在全国多个城市设立门店，业务涵盖黄金、奢侈品、房产、汽车等多个典当品类。公司汇聚了一批专业的评估师和金融服务团队，始终坚持公平、公正、透明的服务理念，在行业内树立了良好口碑。</p>
					<p class="mb-30">现诚邀您加入联丰典当!</p>
					<p>与我们携手，共同推动普惠金融发展，为中小企业和个人提供专业、可靠的金融服务，让典当融资更高效、更便捷。</p></p>
				</div>
				<div class="right">
					<div class="channel-apply">
						<div class="form-t">
							<p class="title">渠道合作申请</p>CHANNEL COOPERATION
						</div>
						<div class="apply-ipt">
							<img class="ipt-img" src="../../static/home/user_name.png" alt="" />
							<el-input class="ipt" v-model="userName" placeholder="请输入您的姓名" clearable></el-input>
						</div>
						<div class="apply-ipt">
							<img class="ipt-img" src="../../static/home/phone_number.png" alt="" />
							<el-input class="ipt" v-model="userPhone" placeholder="请输入您的手机号" clearable></el-input>
						</div>
						<div class="verification-code">
							<div class="apply-ipt code-ipt">
								<el-input class="ipt" v-model="code" placeholder="请输入验证码" clearable></el-input>
							</div>
							<img @click="getCode" class="img" :src="img" alt="" />
						</div>
						<div class="apply-btn" @click="submit">立即申请</div>
					</div>
				</div>
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>

<script>
	import Dialog from '../components/Dialog.vue'
	export default {
		components: {Dialog},
		data () {
			return {
				userName: '',
				userPhone: '',
				code: '',
				img: '',
				uuid: '',
				centerDialogVisible: false,
			}
		},
		created() {
			this.getCode()
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = flag
			},
			async getCode() {
				let res = await this.util.request({
					url: `/sy/getLfWebsite/formCode`,
					method: 'GET',
					data: {},
				});
				if (res.status === 200) {
					this.img = res.data.img;
					this.uuid = res.data.uuid;
				} 
			},
			submit() {
				if (this.userName == '') {
					this.$message.error('请输入姓名');
					return false
				}
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				if (this.code == '') {
					this.$message.error('请输入验证码');
					return false
				}
				
				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 1,
						userName: this.userName,
						userPhone: this.userPhone,
						clueType: 1,
						uuid: this.uuid,
						code: this.code,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible = true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
		}
	}
</script>

<style scoped>
	.cooperate_con {
		color: #fff;
	}
	.channel-apply {
		background: rgba(0, 0, 0, .3);
		border-radius: 8px;
		padding: 40px 43px 60px;
	}
	
	.form-t {
		font-size: 14px;
		color: #CF2427;
		margin-bottom: 20px;
	}
	
	.form-t .title {
		font-weight: 600;
		font-size: 26px;
		color: #FFFFFF;
	}
	
	.apply-ipt {
		padding: 0 11px;
		height: 44px;
		line-height: 44px;
		background: #FFFFFF;
		border-radius: 22px;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}
	
	.ipt-img {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}
	
	.ipt::placeholder {
		color: #999;
	}
	
	.ipt .el-input__inner {
		border: none ;
		font-size: 13px;
		color: #333;
		padding: 0;
	}
	
	.apply-btn {
		width: 234px;
		height: 44px;
		line-height: 44px;
		background: #CF2427;
		border-radius: 22px;
		font-weight: 600;
		font-size: 15px;
		color: #FFFFFF;
		text-align: center;
	}
	.verification-code {
		display: flex;
	}
	.code-ipt {
		width: 105px;
		margin-right: 10px;
	}
	.verification-code .img {
		cursor: pointer;
		width: 94px;
		height: 44px;
		background: #FFFFFF;
	}
</style>


// WEBPACK FOOTER //
// src/view/channel.vue